
export default {
  // Airport details
  "rank": "순위",
  "hand_check_rate": "수동 검사 비율",
  "reviews": "리뷰",
  "loading_airport": "공항 세부정보 로딩 중...",
  "airport_not_found": "공항을 찾을 수 없습니다",
  "airport_reviews": "공항 리뷰",
  "no_reviews_yet_share": "아직 리뷰가 없습니다",
  "share_film_community": "필름 커뮤니티와 당신의 경험을 공유하세요!",
  "add_review_button": "리뷰 추가",
  "back_to_lenses": "렌즈로 돌아가기",
  "back_to_cameras": "카메라로 돌아가기",
  "failed_load_lens": "렌즈 세부정보 로딩 실패",
  "lens_not_found": "렌즈를 찾을 수 없습니다",
  "favorite_airports": "즐겨찾는 공항",
  "no_favorite_airports": "아직 즐겨찾는 공항이 없습니다",
  "user_favorites": "사용자 즐겨찾기",
  "manage_favorites": "즐겨찾기 관리",
  "remove_from_favorites": "즐겨찾기에서 제거",
  "add_to_favorites": "즐겨찾기에 추가",
  "airport_added_favorites": "공항이 즐겨찾기에 추가되었습니다",
  "airport_removed_favorites": "공항이 즐겨찾기에서 제거되었습니다",
};
